/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { IAttachmentValue } from '@apitable/core';
import classNames from 'classnames';
import { FC, useEffect, useRef } from 'react';
import styles from './style.module.less';

interface IItemProps {
  index: number;
  active: boolean;
  setActiveIndex(index: number): void;
  file: IAttachmentValue;
  imgSrc: string;
}

export const Item: FC<React.PropsWithChildren<IItemProps>> = props => {

  const {
    index,
    active,
    setActiveIndex,
    file,
    imgSrc,
  } = props;

  const activeEleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (active) {
      activeEleRef.current?.scrollIntoView({ block: 'nearest' });
    }
  }, [active]);

  return (
    <div
      tabIndex={-1}
      className={
        classNames({
          [styles.active]: active,
          [styles.item]: true,
          [styles.imgWrapper]: true,
        })
      }
      onClick={() => setActiveIndex(index)}
      ref={activeEleRef}
    >
      <img
        src={imgSrc}
        alt={file.name}
        width={40}
        height={40}
      />
    </div>
  );
};
